/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
interface ListOfPagesObjType {
  name: string;
  key: string;
  icon: string;
  index: number;
}

export const ListOfPages: Array<ListOfPagesObjType> = [
  {
    name: "Customers",
    key: "customers",
    icon: "PlaceInstitution",
    index: 0,
  },
  {
    name: "Applications",
    key: "applications",
    icon: "CatalogRows",
    index: 1,
  }
];
